import React from 'react';

function forwardRef(component) {
  return (
    /*#__PURE__*/
    React.forwardRef(component)
  );
}

export { forwardRef };